import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import ko from "./locales/ko.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ko: { translation: ko },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "ko"],
    load: "languageOnly",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "proteinpal_lang",
      caches: ["localStorage"],
    },
  });

// Keep <html lang> in step with the active language. Korean has no spaces between
// words, so browsers break Korean lines mid-word unless the document declares the
// language and the stylesheet asks for keep-all (see styles.css :lang(ko)).
// Called at boot from index.tsx and on every toggle from LanguageToggle.
export const syncDocumentLang = (lng: string | undefined) => {
  document.documentElement.lang = lng === "ko" ? "ko" : "en";
};

export default i18n;
